<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-flex xs12 sm12 md12 lg12 >
        <v-card class="cardBgColorStyle row--dense">


            <v-card row wrap dark  color="secondary"  dense style="padding:0px 0px">

                <!--程式名稱-->
                <v-flex d-inline-flex pl-2 style="font-size: 1.2rem;vertical-align: middle;">
                    <!--<span>{{this.menuInfo.funTitle}}</span>-->
                    <span>設定掛號條件</span>
                </v-flex>

                <v-flex xs12 sm6 md4 d-inline-flex>
                    <v-flex xs5 sm5 md5 text-right  class="labelFont">
                        <span style="color: white!important;">醫院代號</span>
                    </v-flex>
                    <v-flex xs7 sm7 md7 pl-2>
                        <v-text-field
                                hide-details
                                @keyup.enter="updateValue1(hospIdObj,hospId,'hospId')"
                                class="mr-2"
                                v-model="hospId">
                        </v-text-field>
                    </v-flex>
                </v-flex>

                <v-flex xs12 sm6 md4 d-inline-flex>
                    <v-flex xs5 sm5 md5 text-right  class="labelFont">
                        <span style="color: white!important;">預設院區代號</span>
                    </v-flex>
                    <v-flex xs7 sm7 md7 pl-2>
                        <v-text-field
                                hide-details
                                @keyup.enter="updateValue1(zoneObj,zone,'zone')"
                                v-model="zone">
                        </v-text-field>
                    </v-flex>
                </v-flex>


            </v-card>


            <v-flex style="padding-top: 1rem">
                <v-data-table
                        v-resize="resizeSysSetListGrid"
                        id="sysSetTable"
                        dense
                        hide-default-footer
                        :headers="headers"
                        :items="sysSetList"
                        :loading="loading"
                        @page-count="pagination.pageCount = $event"
                        :page.sync="pagination.page"
                        :sort-by="pagination.sortBy"
                        :sort-desc="pagination.descending"
                        :loading-text="loadingText"
                        :search="search"
                        :items-per-page="pagination.rowsPerPage"
                        class="elevation-1">

                    <template slot="item" slot-scope="props" style="border: 1px solid black">
                        <!--<tr :active="props.selected" @click="props.selected = !props.selected">-->
                        <!--<td>
                          <v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
                        </td>-->
                        <tr>
                            <td class="text-center" style="width:70px">
                                <!--<v-switch  @change="trnasValue1(props.item.value1)" class="mr-2"  style="float: right" hide-details  :label="`${props.item.value1==true?'ON':'OFF'}`" v-model="props.item.value1"></v-switch>-->
                                <!--{{props.item.value1}}-->

                                <v-switch :label="`${props.item.value1==true?'ON':'OFF'}`" class="text-center" @change="trnasValue1(props.item)" :key="props.item.code" v-model="props.item.value1" />

                            </td>
                            <td  class="px-1 text-left">{{ props.item.code}}</td>
                            <td  class="px-1 text-left">{{ props.item.memo}}</td>
                            <td  class="px-1 text-left">
                                <v-text-field hide-details @keyup.enter="trnasValue1(props.item)" solo  v-model="props.item.value2"></v-text-field>
                            </td>
                            <td  class="px-1 text-left">
                                <v-text-field hide-details @keyup.enter="trnasValue1(props.item)" solo  v-model="props.item.value3"></v-text-field>
                            </td>
                            <td  class="px-1 text-left">
                                <v-text-field hide-details @keyup.enter="trnasValue1(props.item)" solo  v-model="props.item.value4"></v-text-field>
                            </td>



                        </tr>
                    </template>

                    <!--<template v-slot:item.value1="props">-->
                    <!--<v-edit-dialog-->
                    <!--:return-value.sync="props.item.value1"-->
                    <!--@save="save"-->
                    <!--@cancel="cancel"-->
                    <!--@open="open"-->
                    <!--@close="close"-->
                    <!--&gt;-->
                    <!--{{ props.item.value1 }}-->
                    <!--<template v-slot:input>-->
                    <!--<v-text-field-->
                    <!--v-model="props.item.value1"-->
                    <!--label="Edit"-->
                    <!--single-line-->
                    <!--counter-->
                    <!--&gt;</v-text-field>-->
                    <!--</template>-->
                    <!--</v-edit-dialog>-->
                    <!--</template>-->
                    <!--<template v-slot:item.value2="props">-->
                    <!--<v-edit-dialog-->
                    <!--:return-value.sync="props.item.value2"-->
                    <!--large-->
                    <!--persistent-->
                    <!--@save="save"-->
                    <!--@cancel="cancel"-->
                    <!--@open="open"-->
                    <!--@close="close"-->
                    <!--&gt;-->
                    <!--<div>{{ props.item.value2 }}</div>-->
                    <!--<template v-slot:input>-->
                    <!--<div class="mt-4 title">-->
                    <!--Update Iron-->
                    <!--</div>-->
                    <!--<v-text-field-->
                    <!--v-model="props.item.value2"-->
                    <!--label="Edit"-->
                    <!--single-line-->
                    <!--counter-->
                    <!--autofocus-->
                    <!--&gt;</v-text-field>-->
                    <!--</template>-->
                    <!--</v-edit-dialog>-->
                    <!--</template>-->
                </v-data-table>
                <v-layout row wrap>
                    <v-flex xs12 md2>
                        <v-text-field
                                v-model="search"
                                class="ml-2 mt-2"
                                prepend-inner-icon="mdi-magnify"
                                single-line
                                hide-details
                                clearable
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6 text-center pt-2>
                        <v-pagination color="accent" v-model="pagination.page" :length="pagination.pageCount" :total-visible="7"></v-pagination>
                    </v-flex>
                    <v-flex xs6 md2 pt-2 pr-2 pl-2>
                        <v-select
                                :items="pageItem"
                                label="每頁筆數"
                                item-value="value"
                                v-model="pagination.rowsPerPage"
                        ></v-select>
                    </v-flex>
                    <v-flex xs6 md2 text-left pt-2 pr-2>
                        <v-text-field
                                label="總筆數"
                                v-model="sysSetList.length"
                                readonly
                        ></v-text-field>
                    </v-flex>
                </v-layout>
            </v-flex>

        </v-card>



        <v-snackbar
                v-model="snStatus"
                :timeout="snTimeout"
                :color="snackColor"
        >
            {{ snText }}
        </v-snackbar>
    </v-flex>
</template>

<script>
    export default {
        name: "RegCondSetting",
        data() {
            return {
                hospId:'',
                zone:'',
                hospIdObj:{},
                zoneObj:{},
                search:'',
                loading:false,
                loadingText:'查詢中...',
                snStatus: false,
                snTimeout:4000,
                snackColor: '',
                snText: '',
                pagination: {
                    sortBy: 'dataType',
                    rowsPerPage:100,
                    page: 1,
                    pageCount: 0,
                    descending:false
                },
                pageItem:[
                    {text:100,value:100},
                    {text:20,value:20},
                    {text:"All",value:-1},
                ],
                pageText:'每頁筆數 :',
                headers:[
                    {
                        text: '值1',
                        align: 'center',
                        value: 'value1'
                    },
                    {
                        text: '代號',
                        // align: 'center',
                        value: 'code',
                        class:'px-1'
                    },
                    {
                        text: '設定說明',
                        // align: 'left',
                        value: 'memo',
                        class:'px-1'
                    },
                    {
                        text: '值2',
                        // align: 'center',
                        value: 'value2',
                        class:'px-1'
                    },
                    {
                        text: '值3',
                        // align: 'center',
                        value: 'value3',
                        class:'px-1'
                    },
                    {
                        text: '值4',
                        // align: 'center',
                        value: 'value4',
                        class:'px-1'
                    },


                ],
                sysSetList: [],
            }
        },
        created(){
            this.axios_getSysSetParamNo();
            this.axios_getSysSetZone();
            this.axios_getSysSetHospId();
        },
        computed:{
            filterData(){
                return this.sysSetList.map(function (item) {
                    item.value1 = item.value1=='ON'?true:false;
                    return item;
                });

            },
        },

        methods:{
            resizeSysSetListGrid:function(){
                var userHeight = window.innerHeight
                    || document.documentElement.clientHeight
                    || document.body.clientHeight;
                var height = userHeight-(275);
                var sysSetTable = document.getElementById('sysSetTable');
                sysSetTable.setAttribute('style','overflow-y: auto;min-height:'+height+'px;max-height:'+height+'px;');
            },
            trnasValue1(item){ //在此呼叫API 修改參數
               item.value1 = item.value1==true?'ON':'OFF';
                this.axios_putSysSet(item,'table')
            },
            updateValue1(item,value1,flag){
                item.value1 = value1
                this.axios_putSysSet(item,flag);
                console.log(item)
            },
            axios_getSysSetHospId (){ //參數代碼HospId
                let url = '';
                this.hospId = '';
                this.hospIdObj = {};
                url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/BASEINFO/HOSP_ID";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.hospId = response.data.resultSet[0].value1;
                        this.hospIdObj = response.data.resultSet[0];
                    }else{
                        this.hospId = '';
                        this.hospIdObj = {};
                    }

                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.hospId = '';
                        this.hospIdObj = {};
                    } catch(err) {
                        console.log(err.toString())
                    }

                });

            },
            axios_getSysSetZone (){ //參數代碼Zone
                let url = '';
                this.zone = '';
                this.zoneObj = {};
                url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/BASEINFO/ZONE";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.zone = response.data.resultSet[0].value1;
                        this.zoneObj = response.data.resultSet[0];
                    }else{
                        this.zone = '';
                        this.zoneObj = {};
                    }

                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.zone = '';
                        this.zoneObj = {};
                    } catch(err) {
                        console.log(err.toString())
                    }

                });

            },
            axios_getSysSetParamNo (){ //參數代碼查詢
                let url = '';
                    this.loading = true;
                    this.sysSetList = [];
                    url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/REGCOND/ALL";

                    this.$http.get(url).then(response =>{
                        if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                            this.sysSetList = response.data.resultSet;
                            this.sysSetList =  this.sysSetList.map(function (item) {
                                item.value1 = item.value1=='ON'?true:false;
                                return item;
                            });
                            this.loading = false;
                        }else{
                            this.sysSetList = [];
                            this.loading = false;
                        }


                    }).catch(error =>  {
                        try {
                            console.log(error.response.data.status);
                            this.sysSetList = [];
                        } catch(err) {
                            this.loading = false;
                        }
                        this.loading = false;
                    });


            },
            axios_putSysSet(putData,flag){ //修改 資料來源
                let postList = [];
                postList.push(putData);
                let url = this.$store.state.AppSetting.backSrvUrl+'iregsetting/';

                this.$http.put(url,postList).then(response=>{
                    this.snStatus=true;

                    if(response.data.resultSet.length>0){
                        if(flag=='table'){ //REGCOND 類別
                            this.axios_getSysSetParamNo();
                        }else if(flag=='hospId'){ //醫院代號
                            this.axios_getSysSetHospId();
                        }else { //院區代號
                            this.axios_getSysSetZone();
                        }

                        this.snText = response.data.message;
                    }
                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;

                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
            save () {
                this.snStatus = true
                this.snackColor = 'success'
                this.snText = 'Data saved'
            },
            cancel () {
                this.snStatus = true
                this.snackColor = 'error'
                this.snText = 'Canceled'
            },
            open () {
                this.snStatus = true
                this.snackColor = 'info'
                this.snText = 'Dialog opened'
            },
            close () {
                console.log('Dialog closed')
            },
        }
    }
</script>

<style scoped>
    .cardBgColorStyle{
        padding:0px 10px;
        background-color: rgba(255,255,255,1);
    }


</style>